const validateSubscriptionProducts = (businessUnitKey: string) => {
  if (!businessUnitKey || typeof (businessUnitKey) !== 'string') return false

  if (businessUnitKey === 'aim' || businessUnitKey === 'engage'){ return true }

  return false
}

export default validateSubscriptionProducts
